/**
 * @generated SignedSource<<8f468660a607bf863c841e5dc7f34d81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespTitle_item$data = {
  readonly classification: {
    readonly creationDate: string | null;
  } | null;
  readonly isArt: boolean | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"getByDocCreator_item">;
  readonly " $fragmentType": "PdpRespTitle_item";
};
export type PdpRespTitle_item$key = {
  readonly " $data"?: PdpRespTitle_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespTitle_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespTitle_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemClassification",
      "kind": "LinkedField",
      "name": "classification",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creationDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "getByDocCreator_item",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemCreator",
          "kind": "LinkedField",
          "name": "creators",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "attribution",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Creator",
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "4625bbe25af12b3b15e3df6c7d24a2ed";

export default node;
